import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { delayWhen, interval, Observable, of } from 'rxjs';
import { MatProgressBar } from '@angular/material/progress-bar';
import { AsyncPipe } from '@angular/common';

@Component({
	selector: 'vex-progress-bar',
	templateUrl: './progress-bar.component.html',
	styleUrls: ['./progress-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatProgressBar, AsyncPipe],
})
export class ProgressBarComponent {
	loader = inject(LoadingBarService);

	value$: Observable<number> = this.loader.useRef('router').value$.pipe(delayWhen((value) => (value === 0 ? interval(200) : of(undefined))));
}
